'use client'
import { CaseTypeMappingModule } from '@repo/case-type-mapping/CaseTypeMappingModule'

const PerfectPortalCaseTypeMapping = () => {
  return <CaseTypeMappingModule />
}

export default PerfectPortalCaseTypeMapping
